export const BLOCK_NAME = "name";
export const BLOCK_TYPE = "type";
export const BLOCK_DESCRIPTION = "description";
export const BLOCK_SHOW_TITLE = "showTitle";
export const BLOCK_TITLE_RU = "titleRu";
export const BLOCK_TITLE_EN = "titleEn";
export const BLOCK_DESCRIPTION_RU = "descriptionRu";
export const BLOCK_DESCRIPTION_EN = "descriptionEn";
export const BLOCK_WATCH_ONLINE = "watchBroadcastOnline";
export const BLOCK_CHECK_CONNECTION = "checkConnection";
export const BLOCK_OFFLINE_PLATFORM = "openOfflinePlatform";

export const BLOCK_ACTIVITIES = "activities";
export const BLOCK_ACTIVITIES_PLATFORM_LINK_ONLINE = "platformLinkOnline";
export const BLOCK_ACTIVITIES_PLATFORM_LINK_OFFLINE = "platformLinkOffline";
export const BLOCK_ACTIVITIES_EVENT_ADDRESS = "eventAddress";

export const BLOCK_BUTTONS = "buttons";
export const BLOCK_BUTTON_TITLE_RU = "titleRu";
export const BLOCK_BUTTON_TITLE_EN = "titleEn";
export const BLOCK_BUTTON_LINK = "link";
export const BLOCK_BUTTON_OPTIONS = "options";
export const BLOCK_BUTTON_QUIZ_KEY = "quizKey";

export const BLOCK_BUTTON_TYPE = "type";
export const BLOCK_BUTTON_TYPE_CUSTOM = "custom";
export const BLOCK_BUTTON_TYPE_QUIZ = "quiz";
export const BLOCK_BUTTON_TYPE_WATCH_BROADCAST_ONLINE =
    "watch.broadcast.online";
export const BLOCK_BUTTON_TYPE_CHECK_CONNECTION = "check.connection";
export const BLOCK_BUTTON_TYPE_OPEN_OFFLINE_PLATFORM = "open.offline.platform";

export const BLOCK_TYPE_GREETING = "greeting";
export const BLOCK_TYPE_MAIN_INFO_ONLINE = "main.info.online";
export const BLOCK_TYPE_MAIN_INFO_OFFLINE = "main.info.offline";
export const BLOCK_TYPE_ORGANIZER_CONTACTS = "organizer.contacts";
export const BLOCK_TYPE_CALENDAR_ONLINE = "calendar.online";
export const BLOCK_TYPE_CALENDAR_OFFLINE = "calendar.offline";
export const BLOCK_TYPE_DISCLAIMER = "disclaimer";
export const BLOCK_TYPE_CUSTOM = "custom";
export const BLOCK_TYPE_PASSWORD = "password";
export const BLOCK_TYPE_QUESTIONNAIRE = "questionnaire";
export const BLOCK_TYPE_CERTIFICATE = "certificate";
export const BLOCK_TYPE_QRCODE_OFFLINE = "qrcode.offline";
